export default __webpack_public_path__ + "static/media/Instagram.765fef6b.mp4";